export default __webpack_public_path__ + "static/media/785.27c24455.png";